(function () {
  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function stripMarks(node) {
    if (!node) return;
    node.querySelectorAll("mark").forEach((m) => {
      m.replaceWith(document.createTextNode(m.textContent));
    });
  }

  function highlight(node, query) {
    if (!node || !query) return;
    stripMarks(node);

    const q = query.trim();
    if (!q) return;

    const re = new RegExp("(" + escapeRegExp(q) + ")", "ig");
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);

    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((t) => {
      const val = t.nodeValue;
      if (!val || !re.test(val)) return;

      const frag = document.createDocumentFragment();
      let last = 0;

      val.replace(re, (match, _g, idx) => {
        frag.appendChild(document.createTextNode(val.slice(last, idx)));
        const mark = document.createElement("mark");
        mark.textContent = match;
        frag.appendChild(mark);
        last = idx + match.length;
        return match;
      });

      frag.appendChild(document.createTextNode(val.slice(last)));
      t.parentNode.replaceChild(frag, t);
    });
  }

  function initFAQ(root) {
    const input = root.querySelector("[data-faq-search]");
    const clearBtn = root.querySelector("[data-faq-clear]");
    const list = root.querySelector("[data-faq-list]");
    const details = Array.from(list?.querySelectorAll("details.faq-item") || []);
    const countEl = root.querySelector("[data-faq-count]");
    const noResults = root.querySelector("[data-faq-noresults]");

    if (!input || !list || !details.length) return;

    // Always start closed, and remove any forced open attributes
    details.forEach((d) => d.removeAttribute("open"));

    // Only one open at a time
    details.forEach((d) => {
      d.addEventListener("toggle", () => {
        if (!d.open) return;
        details.forEach((other) => {
          if (other !== d) other.removeAttribute("open");
        });
      });
    });

    function setCount(visible) {
      if (!countEl) return;
      countEl.textContent =
        visible === details.length
          ? `${details.length} questions`
          : `${visible} of ${details.length} questions`;
    }

    function runFilter() {
      const q = input.value.trim().toLowerCase();

      let visible = 0;
      details.forEach((d) => {
        const summary = d.querySelector("summary");
        const content = d.querySelector(".faq-content");

        stripMarks(d);

        const hay =
          (summary?.innerText || "") + " " + (content?.innerText || "");
        const match = !q || hay.toLowerCase().includes(q);

        d.hidden = !match;

        if (match && q) {
          if (summary) highlight(summary, q);
          if (content) highlight(content, q);
        }

        if (match) visible++;
      });

      setCount(visible);
      if (noResults) noResults.hidden = visible !== 0;
    }

    // initial
    setCount(details.length);

    // debounce typing
    let t;
    input.addEventListener("input", () => {
      window.clearTimeout(t);
      t = window.setTimeout(runFilter, 80);
    });

    clearBtn?.addEventListener("click", () => {
      input.value = "";
      input.focus();
      runFilter();
    });

    // prefill ?q=
    const params = new URLSearchParams(window.location.search);
    const prefill = params.get("q");
    if (prefill) {
      input.value = prefill;
      runFilter();
    }
  }

  function boot() {
    document.querySelectorAll("[data-faq]").forEach(initFAQ);
  }

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("pageshow", boot);
})();
/* ==============================
   SUPPIST — FAQ Schema (JSON-LD)
   Auto-generates FAQPage schema from the FAQ accordions on the page
   ============================== */

(function () {
  function cleanText(str) {
    if (!str) return "";
    return str
      .replace(/\s+/g, " ")
      .replace(/\u00A0/g, " ")
      .trim();
  }

  function extractTextFromEl(el) {
    if (!el) return "";
    // Clone so we can remove unwanted nodes without touching UI
    const clone = el.cloneNode(true);

    // Remove elements that shouldn't be included
    clone.querySelectorAll("script, style, noscript").forEach((n) => n.remove());

    // Convert links to their visible text (Google accepts plain text best in FAQ)
    clone.querySelectorAll("a").forEach((a) => {
      const text = document.createTextNode(a.textContent || "");
      a.replaceWith(text);
    });

    return cleanText(clone.textContent || "");
  }

  function buildFaqSchema(root) {
    const items = [];

    const detailNodes = root.querySelectorAll("details.faq-item");
    detailNodes.forEach((d) => {
      const summary = d.querySelector("summary");
      const content = d.querySelector(".faq-content");

      const q = cleanText(summary ? summary.textContent : "");
      const a = extractTextFromEl(content);

      // Only include valid Q/A pairs
      if (!q || !a) return;

      items.push({
        "@type": "Question",
        "name": q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": a
        }
      });
    });

    if (!items.length) return null;

    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": items
    };
  }

  function injectJsonLd(schemaObj) {
    // Avoid duplicates
    const existing = document.getElementById("suppist-faq-schema");
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "suppist-faq-schema";
    script.text = JSON.stringify(schemaObj);
    document.head.appendChild(script);
  }

  document.addEventListener("DOMContentLoaded", function () {
    const root = document.querySelector("[data-suppist-faq]");
    if (!root) return;

    const schema = buildFaqSchema(root);
    if (schema) injectJsonLd(schema);
  });
})();


